import { render, staticRenderFns } from "./feed.vue?vue&type=template&id=0a38b5a1&scoped=true&"
import script from "./feed.vue?vue&type=script&lang=js&"
export * from "./feed.vue?vue&type=script&lang=js&"
import style0 from "./feed.vue?vue&type=style&index=0&id=0a38b5a1&lang=scss&scoped=true&"
import style1 from "./feed.vue?vue&type=style&index=1&id=0a38b5a1&lang=scss&scoped=true&"
import style2 from "./feed.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38b5a1",
  null
  
)

export default component.exports